import { Component, OnDestroy, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { Subscription } from 'rxjs';
import { AnalyticsService } from './services/analytics.service';
import { ConsentService } from './services/consent.service';
import { ConsentUiService } from './services/consent-ui.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  showConsentModal = false;
  showConsentCustomization = false;
  consentAnalytics = false;
  consentAds = false;
  readonly appLinks = [
    { label: 'Noisy Radio', href: 'https://noisyradio.wahl.website' },
    { label: 'Noisy Podcaster', href: 'https://noisypodcaster.wahl.website' },
    { label: 'Noisy Sleeper', href: 'https://noisysleeper.wahl.website' },
  ];

  private subscriptions = new Subscription();

  constructor(
    private consentService: ConsentService,
    private consentUi: ConsentUiService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.configureStatusBar();
    if (!this.consentService.hasStoredConsent()) {
      this.consentService.acceptAll();
    }
    this.syncConsentState();
    this.analyticsService.start();

    this.subscriptions.add(
      this.consentUi.open$.subscribe(() => {
        this.openConsentPreferences(true);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  openConsentPreferences(forceCustomize = false): void {
    this.syncConsentState();
    this.showConsentCustomization = forceCustomize || this.consentService.hasStoredConsent();
    this.showConsentModal = true;
  }

  closeConsentModal(): void {
    this.showConsentModal = false;
    this.showConsentCustomization = false;
  }

  acceptAllConsent(): void {
    this.consentService.acceptAll();
    this.closeConsentModal();
  }

  rejectAllConsent(): void {
    this.consentService.rejectAll();
    this.closeConsentModal();
  }

  saveCustomConsent(): void {
    this.consentService.saveCustom(this.consentAnalytics, this.consentAds);
    this.closeConsentModal();
  }

  private syncConsentState(): void {
    const state = this.consentService.getState();
    this.consentAnalytics = state?.analytics ?? false;
    this.consentAds = state?.ads ?? false;
  }

  private configureStatusBar(): void {
    if (Capacitor.getPlatform() !== 'android') {
      return;
    }

    StatusBar.setOverlaysWebView({ overlay: false })
      .catch((error) => {
        console.warn('[StatusBar] Failed to disable overlay', error);
      });
  }
}
